import { motion } from 'framer-motion'
import { cn } from '@/lib/utils'

/**
 * The highlight a grid of cards shares.
 *
 * Only the hovered card renders it, and because every instance carries the same
 * `layoutId`, moving to the next card animates this one across rather than
 * fading one out and another in — the pointer drags it like a magnet.
 */
export function CardHighlight({
  id,
  radius = 20,
  className,
}: {
  id: string
  radius?: number
  /** For a card that stacks its own layers and needs the edge lifted above them. */
  className?: string
}) {
  return (
    <motion.span
      aria-hidden
      layoutId={id}
      style={{ borderRadius: radius }}
      className={cn(
        'pointer-events-none absolute inset-0 bg-foreground/[0.012] ring-2 ring-inset ring-[hsl(var(--foreground)/0.07)] dark:ring-primary/25',
        className
      )}
      transition={{ type: 'spring', stiffness: 380, damping: 34, mass: 0.6 }}
    />
  )
}
